module.exports = __webpack_public_path__ + "img/spend-coins.587a58d1.svg";